import { Favicon } from '@fhs/ui';

import { IconContainer } from './icon-container';

export const SelectPermissions = () => (
  <IconContainer>
    <Favicon size={20} />
  </IconContainer>
);
